import http from "@/http-common";

class loginService {
   login(data) {
      return http.post("/customer/login", data).then((res) => {
         return res.data;
      });
   }
   resetPassword(data) {
      return http.post("/customer/new-password", data).then((res) => {
         return res.data;
      });
   }
   forgetPassword(data) {
      return http.post("/customer/forget-password", data).then((res) => {
         return res.data;
      });
   }
}

export default new loginService();
